import { render, staticRenderFns } from "./DetailBroadcast.vue?vue&type=template&id=66c81ace&"
import script from "./DetailBroadcast.vue?vue&type=script&lang=js&"
export * from "./DetailBroadcast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports